import {useCallback, useContext, useMemo} from 'react'
import {OrgCustomizationContext} from "../themes/OrgCustomizationProvider";
import {AppContext} from "../contexts/AppContextProvider";

const useRedirect = () => {
    const {storeUrl, language} = useContext(OrgCustomizationContext)
    const {countryCode} = useContext(AppContext)
    const navigationCountryCode = useMemo(
        () => countryCode === 'int' || !countryCode ? 'international' : countryCode,
        [countryCode]
    )
    const registerUrl = useMemo(
        () => `${storeUrl}/${navigationCountryCode}/${language}/customer/account/create/`,
        [storeUrl, navigationCountryCode, language]
    )
    const loginUrl = useMemo(
        () => `${storeUrl}/${navigationCountryCode}/${language}/customer/account/login/`,
        [storeUrl, navigationCountryCode, language]
    )

    const redirect = useCallback((to: 'login' | 'register') => {
        switch (to) {
            case 'login':
                window.location.href = loginUrl
                break
            case 'register':
                window.location.href = registerUrl
                break
        }
    }, [loginUrl, registerUrl])

    return {redirect, registerUrl, loginUrl}
}

export default useRedirect
